import { getCourseDescriptionPlainText } from './courseDescriptionHtml';

/**
 * @param {string | undefined | null} raw
 * @param {number} [maxLen]
 * @returns {string}
 */
export function buildCourseDescriptionSnippet(raw, maxLen = 120) {
  const normalized = getCourseDescriptionPlainText(typeof raw === 'string' ? raw : '');
  if (normalized.length === 0) {
    return '';
  }
  if (normalized.length <= maxLen) {
    return normalized;
  }
  return `${normalized.slice(0, maxLen - 1).trim()}…`;
}
